import { ApprovedStatus } from '../constants/approvedStatus';
import { TAB_DROPSHIP, TAB_REORDER } from '../constants/mainConstants';

export function getApprovedStatusForVariants({ variants, permissionType }) {
  if (permissionType === TAB_DROPSHIP) {
    const approved = variants.some((variant) => variant.permission && variant.permission.ecommerce_approved);
    if (approved) {
      const approvedByRetailer = variants.some((variant) => variant.permission?.ecommerce_approved_by_retailer);
      return approvedByRetailer ? ApprovedStatus.SYNCED : ApprovedStatus.PENDING;
    } else {
      return ApprovedStatus.NOT_APPROVED;
    }
  } else if (permissionType === TAB_REORDER) {
    const approved = variants.some((variant) => variant.permission && variant.permission.replenish_approved);
    return approved ? ApprovedStatus.SYNCED : ApprovedStatus.NOT_APPROVED;
  }

  return ApprovedStatus.NOT_APPROVED;
}

export function getRetailerProductApprovedStatusForVariants({ product }) {
  const numberOfVariants = product.variants.length;
  const numberOfApprovedVariants = product.retailer_approved_variants_count;

  if (numberOfApprovedVariants === numberOfVariants) return ApprovedStatus.SYNCED;
  if (numberOfApprovedVariants > 0) return ApprovedStatus.PENDING;
  return ApprovedStatus.NOT_APPROVED;
}
